import { render, staticRenderFns } from "./equityPersonnelDetails.vue?vue&type=template&id=51e7b9cd&scoped=true&"
import script from "./equityPersonnelDetails.vue?vue&type=script&lang=js&"
export * from "./equityPersonnelDetails.vue?vue&type=script&lang=js&"
import style0 from "./equityPersonnelDetails.vue?vue&type=style&index=0&id=51e7b9cd&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e7b9cd",
  null
  
)

export default component.exports